import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { tap } from "rxjs/operators";

import { process, State, CompositeFilterDescriptor, distinct, GroupDescriptor } from "@progress/kendo-data-query";

import { Global } from 'projects/shared-lib/src/lib/_constants/global.variables';
import { DataService } from 'projects/shared-lib/src/lib/services/data.service';
import { IGlobal } from 'projects/shared-lib/src/lib/_models/global.model';


@Component({
  selector: "app-customer-reports",
  templateUrl: "./customer-reports.component.html",
  styleUrls: ["./customer-reports.component.scss"],
})
export class CustomerReportsComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  customerReportsLoading = true;
  @ViewChild("reportViewerHost") reportViewerHost: ElementRef<HTMLElement>;
  private reportViewerSelectionObserver: MutationObserver | null = null;
  private observerHostElement: HTMLElement | null = null;
  viewerContainerStyle = {
    position: "relative",
    width: "100%",
    height: "100%",
    ["font-family"]: "ms sans serif",
  };
  public global: IGlobal = Global;
  authenticationToken: string;
  categories: any;
  reports: any;
  public gridViewReports: any;
  public state: State = { skip: 0 };
  public reportsState: State = { skip: 0 };
  public viewReportsList: boolean = true;
  public displayReport: boolean = false;
  public reportSourceObject: any;
  public groups: GroupDescriptor[] = [{ field: "CategoryName" }];
  currentReportName: string;
  public userReportCategories: any;
  public reportsServerUrl: string;

  constructor(private http: HttpClient, private dataService: DataService) {
	 this.reportsServerUrl = Global.Data.reportsServerUrl;

  }

  execute(report) {
    this.currentReportName = report.CategoryName + "/" + report.Name;
    this.reportSourceObject = {
      report: report.CategoryName + "/" + report.Name,
      parameters: {
        accessToken: Global.User.currentUser.AuthenticationTokenFromUserRecord,
      },
    };
    console.log(report);
    this.viewReportsList = false;
    this.displayReport = true;
    setTimeout(() => this.initializeReportViewerSelectionObserver(), 0);
  }

  reportList(refresh?: boolean) {
    //console.log("going back to reports list...");
    this.viewReportsList = true;

    this.displayReport = false;
  }

  ngAfterViewInit(): void {
    this.initializeReportViewerSelectionObserver();
  }

  ngAfterViewChecked(): void {
    if (this.displayReport) {
      this.initializeReportViewerSelectionObserver();
    }
  }

  ngOnDestroy(): void {
    if (this.reportViewerSelectionObserver) {
      this.reportViewerSelectionObserver.disconnect();
      this.reportViewerSelectionObserver = null;
    }
  }

  private initializeReportViewerSelectionObserver(): void {
    const host = this.reportViewerHost?.nativeElement;
    if (!host) {
      return;
    }

    if (
      this.reportViewerSelectionObserver &&
      this.observerHostElement === host
    ) {
      return;
    }

    if (this.reportViewerSelectionObserver) {
      this.reportViewerSelectionObserver.disconnect();
      this.reportViewerSelectionObserver = null;
    }
    this.observerHostElement = host;

    const syncSelectionStyles = () => {
      const isLightTheme = (this.global?.Theme || "").toLowerCase() === "light";
      const darkShellElements = host.querySelectorAll<HTMLElement>(
        ".trv-pages-area, .trv-pages-pane, .trv-page-container, .trv-page-wrapper, .trv-content-wrapper, .trv-content.trv-document-map-splitter"
      );
      darkShellElements.forEach((shellElement) => {
        if (isLightTheme) {
          shellElement.style.removeProperty("background-color");
          shellElement.style.removeProperty("background-image");
        } else {
          shellElement.style.setProperty("background-color", "#27304c", "important");
          shellElement.style.setProperty("background-image", "none", "important");
        }
      });

      const parameterPaneElements = host.querySelectorAll<HTMLElement>(
        ".trv-parameters-area, .trv-parameters-area-content, .trv-parameters-area-footer, .trv-parameters-wrapper, .trv-parameter-container, .trv-parameters-area-overlay"
      );
      parameterPaneElements.forEach((paneElement) => {
        paneElement.style.setProperty("--kendo-color-border", "#b7d3df", "important");
        paneElement.style.setProperty("--kendo-color-primary", "#13688c", "important");
        paneElement.style.setProperty("border-color", "#b7d3df", "important");
        paneElement.style.setProperty("border-top-color", "#b7d3df", "important");
        paneElement.style.setProperty("box-shadow", "none", "important");
        paneElement.style.setProperty("outline", "none", "important");
        paneElement.style.setProperty("background-image", "none", "important");
      });

      const parameterHostPaneElements = host.querySelectorAll<HTMLElement>(
        ".trv-parameters-splitter > .k-pane, .trv-parameters-splitter > .k-pane-static, .trv-parameters-splitter .k-pane"
      );
      parameterHostPaneElements.forEach((hostPaneElement) => {
        hostPaneElement.style.setProperty("--kendo-color-border", "#b7d3df", "important");
        hostPaneElement.style.setProperty("--kendo-color-primary", "#13688c", "important");
        hostPaneElement.style.setProperty("border-color", "#b7d3df", "important");
        hostPaneElement.style.setProperty("border-top-color", "#b7d3df", "important");
        hostPaneElement.style.setProperty("box-shadow", "none", "important");
        hostPaneElement.style.setProperty("background-image", "none", "important");
      });

      const parameterErrorPaneElements = host.querySelectorAll<HTMLElement>(
        ".trv-parameters-area .trv-error-pane, .trv-parameters-area .k-tooltip-validation, .trv-parameters-area .k-callout"
      );
      parameterErrorPaneElements.forEach((errorPaneElement) => {
        errorPaneElement.style.setProperty("background", "transparent", "important");
        errorPaneElement.style.setProperty("background-color", "transparent", "important");
        errorPaneElement.style.setProperty("background-image", "none", "important");
        errorPaneElement.style.setProperty("border-color", "transparent", "important");
        errorPaneElement.style.setProperty("box-shadow", "none", "important");
        errorPaneElement.style.setProperty("outline", "none", "important");
      });

      const parameterCardElements = host.querySelectorAll<HTMLElement>(
        ".trv-parameters-area .trv-parameter-container, .trv-parameters-area .trv-parameter-header, .trv-parameters-area .trv-parameter-value, .trv-parameters-area .k-card, .trv-parameters-area .k-card-header, .trv-parameters-area .k-card-body"
      );
      parameterCardElements.forEach((cardElement) => {
        cardElement.style.setProperty("--kendo-color-border", "#b7d3df", "important");
        cardElement.style.setProperty("--kendo-color-primary", "#13688c", "important");
        cardElement.style.setProperty("border-color", "#b7d3df", "important");
        cardElement.style.setProperty("border-top-color", "#b7d3df", "important");
        cardElement.style.setProperty("box-shadow", "none", "important");
        cardElement.style.setProperty("outline", "none", "important");
      });

      const optionElements = host.querySelectorAll<HTMLElement>(
        ".trv-parameters-area [role='option']"
      );

      optionElements.forEach((optionElement) => {
        const isSelected = optionElement.getAttribute("aria-selected") === "true";
        if (isSelected) {
          optionElement.style.setProperty("background", "#13688c", "important");
          optionElement.style.setProperty("background-image", "none", "important");
          optionElement.style.setProperty("border-color", "#13688c", "important");
          optionElement.style.setProperty("color", "#ffffff", "important");
          optionElement.style.setProperty("font-weight", "600", "important");
          optionElement.style.setProperty("box-shadow", "inset 0 0 0 1px #0f5776", "important");
        } else {
          optionElement.style.setProperty("background", "transparent", "important");
          optionElement.style.setProperty("background-image", "none", "important");
          optionElement.style.setProperty("border-color", "transparent", "important");
          optionElement.style.removeProperty("color");
          optionElement.style.setProperty("font-weight", "400", "important");
          optionElement.style.setProperty("box-shadow", "none", "important");
        }
      });
    };

    syncSelectionStyles();

    this.reportViewerSelectionObserver = new MutationObserver(() => {
      syncSelectionStyles();
    });

    this.reportViewerSelectionObserver.observe(host, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-selected", "class"],
    });
  }

ngOnInit() {
    let httpHeaders = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "",
    });
    let httpOptions = {
      headers: httpHeaders,
      observe: "response" as "response",
      reponseType: "x-www-form-urlencoded",
      withCredentials: false,
    };
    const http$ = this.http
      .post(Global.Data.reportsServerUrl + "/Token",
		"grant_type=password&username=iops-application&password=d19476A9331BCA9C326E6F607651A240CD4DC0CDFD9BF5B29E43A3A4D31D0A6A!", httpOptions)
      .toPromise()
      .then((data: any) => {
        let httpGetHeaders = new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + data.body.accessToken,
        });
		console.log("access_token",data.body);
        this.authenticationToken = data.body.accessToken;
        let httpGetOptions = {
          headers: httpGetHeaders,
          observe: "response" as "response",
          reponseType: "x-www-form-urlencoded",
          withCredentials: false,
        };
        console.log(data);
        this.http
          .get(Global.Data.reportsServerUrl + "/api/reportserver/v2/categories", httpGetOptions)
          .toPromise()
          .then((data: any) => {
            let categories: any = data.body;
            console.log(categories);
            this.categories = categories;
            let statement = "API.GetUserReportCategories @Username = '" + this.global.User.currentUser.Username + "'";
            this.dataService.SQLActionAsPromise(statement).then((data: any) => {
              console.log(data);

              this.userReportCategories = [];
              data.forEach((category) => {
                this.userReportCategories.push(category.Name);
              });

              this.http
                .get(Global.Data.reportsServerUrl + "/api/reportserver/v2/reports", httpGetOptions)
                .toPromise()
                .then((data: any) => {
                  this.reports = data.body;

                  this.reports.forEach((report) => {
                    report.CategoryName = this.categories.find((category) => category.Id === report.CategoryId).Name;
                  });

                  this.reports = this.reports.filter((report) => {
                    return this.userReportCategories.indexOf(report.CategoryName) != -1;
                  });
                  this.customerReportsLoading = false;
                  this.gridViewReports = process(this.reports, { group: this.groups });
                });
            });
          });
      });
  }
}
